import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/error-logger-provider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/index.css");
